import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import Button from '../inputs/Button';
import { setNotificationMessage } from '../../../redux/features/general/notification';
import CancelButton from '../inputs/CancelButton';
import { setDashboardSection, setIsCancelSubscriptionPopupOpened, setIsSuspendedGroupPopupOpened } from '../../../redux/features/general/navigation';
import { cancelSubscription } from '../../../routes/doctor/billing';
import { setIsRefreshSubscription } from '../../../redux/features/doctor/billing/billing';

interface Props { 

}; 

const SuspendedGroupPopup: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 
    const isMobile = useMediaQuery('(max-width: 768px)');

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    const handleNavigation = async () => {

        dispatch(setDashboardSection('billing')); 

        navigate('/group'); 

        dispatch(setIsSuspendedGroupPopupOpened(false)); 

    };

    // -- 

    const handleQuit = () => { 

        dispatch(setIsSuspendedGroupPopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Box 
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100vw',
                height: '100vh', 
                backgroundColor: colors?.popup, 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 100000000,
        }}>

            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly',
                    textAlign: 'center', 
                    maxWidth: isMobile ? '90vw' : '450px',
                    width: '100%',
                    padding: isMobile ? 2 : 3, 
                    borderRadius: 5,
                    fontSize: 14,
                    backgroundColor: colors?.container,
                }}
            >

                <Box
                    sx={{ 
                        width: '90%',
                        fontSize: 16, 
                        fontWeight: 'bold', 
                        marginBottom: 1 
                    }}
                >{t('suspendedAccount')}

                </Box>

                <Box
                    sx={{ 
                        width: '90%',
                        marginBottom: 1 
                    }}
                >{t('suspendedGroupPopup')}

                </Box>

                <Button 
                    title={'continue'}
                    triggerFunction={handleNavigation}
                    extraStyle={{ 
                        marginBottom: 2,
                        backgroundColor: colors?.red,
                        '&:hover': { 
                            color: 'white',
                            backgroundColor: 'rgb(232, 98, 30)'
                        }
                    }}
                />

                <CancelButton handler={handleQuit} extraStyle={{ fontSize: 30 }} />

            </Box>

        </Box>

  );

};

export default SuspendedGroupPopup;